import { createElement } from "react";
import { Redirect } from "react-router-dom";

export default function getRoutes(parent = "", error404) {
  return [
    {
      exact: true,
      path: "/auth/login",
      component: () => createElement(Redirect, {
        to: "/request",
      }),
    },
    {
      exact: true,
      path: "/auth/recovery",
      component: () => createElement(Redirect, {
        to: "/request",
      }),
    },
    error404,
  ];
}
